import * as yup from "yup";
// Personal Info Schema
export const personalInfoSchema = yup.object({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  dateOfBirth: yup.string().required("Date of Birth is required"),
  mobileNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Mobile number is not valid")
    .required("Mobile Number is required"),
  email: yup
    .string()
    .email("Enter a valid email")
    .required("Email is required"),
  permanentHomeAddress: yup.string().required("Address is required"),
  gender: yup.string().required("Gender is required"),
  // socialMediaHandle: yup.string().required("Social Media Handle is required"),
  city: yup.string().required("City is required"),
  state: yup.string().required("State is required"),
  zipcode: yup
    .string()
    .matches(/^[1-9][0-9]{5}$/, "Enter a valid 6-digit Indian zipcode")
    .required("Zipcode is required"),
  district: yup.string().required("District is required"),
  // profilePhoto: yup.mixed().nullable().required("Profile Photo is required"), // For file uploads
});

// Completed Education Item Schema
export const completedEducationItemSchema = yup.object({
  nameSchoolCollege: yup
    .string()
    .required("Name of School/College is required"),
 
  schoolCollegeAddress: yup.string().required("Address is required"),
  nameOfUniversity: yup.string().required("University Name is required"),
  standardStream: yup.string().required("Standard/Stream is required"),
  marksObtainedCGPA: yup.string().required("Marks/CGPA is required"),
  yearOfPassing: yup.string().required("Year of Passing is required"),
  principalName: yup.string().required("Principal Name is required"),
  principalContactNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Contact number is not valid")
    .required("Principal Contact Number is required"),
  uploadMarksheet: yup.mixed().nullable(), // For file uploads
 
});

// Present Education Schema
export const presentEducationSchema = yup.object({
  nameSchoolorCollege: yup
    .string()
    .required("School/College Name is required"),
  schoolCollegeAddress: yup
    .string()
    .required("School/College Address is required"),

  nameOfUniversity: yup
    .string()
    .required("University Name is required"),

  standardStream: yup
    .string()
    .required("Standard/Stream is required"),

  yearOfAdmission: yup
    .string()
    // .matches(/^\d{4}$/, "Enter a valid admission year (YYYY format)")
    .required("Year of Admission is required"),

  currentSemester: yup
    .string()
    .required("Current Semester is required"),

  courseDuration: yup
    .string()
    .required("Course Duration is required"),

  principalName: yup
    .string()
    .required("Principal Name is required"),

  principalContactNumber: yup
    .string()
    .matches(/^[0-9]{10}$/, "Enter a valid 10-digit mobile number")
    .required("Principal Contact Number is required"),

  courseFees: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Enter a valid course fee")
    .required("Course Fees is required"),

  paymentFrequency: yup
    .string()
    .required("Payment Frequency is required"),

  totalFeesPaid: yup
    .string()
    .matches(/^\d+(\.\d{1,2})?$/, "Enter a valid paid amount")
    .required("Total Fees Paid is required"),
});

// Achievement Item Schema
export const achievementItemSchema = yup.array().of(
  yup.object({
    fileName: yup.string().nullable().notRequired(),
    file: yup.mixed().nullable().notRequired(),
  })
);

// Family Details Schema
export const familyDetailsSchema = yup.object({
  fathersName: yup.string().required("Father's Name is required"),
  mothersName: yup.string().required("Mother's Name is required"),
  guardiansName: yup.string().required("Father's/Guardian's Name is required"),
  fathersOccupation: yup.string().required("Occupation of Father is required"),
  mothersOccupation: yup.string().required("Occupation of Mother is required"),
  familyIncome: yup
    .number()
    .typeError("Family Income must be a number")
    .min(0, "Family Income cannot be negative")
    .required("Monthly Family Income is required"),
  contactNumber: yup
    .string()
    .required("Father's/Guardian's Contact Number is required")
    .matches(
      /^[0-9]{10}$/,
      "Contact Number must be a valid Indian phone number (e.g., +911234567890)"
      
    ),
  // siblings: yup.array().of(
  //   yup.object().shape({
  //     name: yup.string().required("Sibling Name is required"),
  //     relationship: yup.string().required("Relationship is required"),
  //     qualification: yup.string().required("Qualification is required"),
  //   })
  // ),
});

// Scholarship Purpose Schema
export const scholarshipPurposeSchema = yup.object({
  purposeExplanation: yup.string().required("Purpose explanation is required"),
  knowApplication: yup.string().required("Application is required"),
  // otherScholarships: yup.array().of(
  //   yup.object().shape({
  //     scholarshipsName: yup.string().required("Scholarships Name is required"),
  //     scholarshipsAmount: yup
  //       .string()
  //       .required("Scholarships Amount is required"),
  //   })
  // ),
});

// Uploaded Document Item Schema
export const uploadedDocumentItemSchema = yup.object({
  fileName: yup.string().required("File Name is required"),
  // file: yup.mixed().nullable().required("File is required"),
});

// Bank Details Schema
export const bankDetailsSchema = yup.array().of(
  yup.object({
    bankName: yup.string().required("Bank Name is required"),
    accountHolderName: yup.string().required("Account Holder Name is required"),
    accountNumber: yup.string().required("Account Number is required"),
    ifscCode: yup.string().required("IFSC Code is required"),
    branchName: yup.string().required("Branch Name is required"),
  })
);

// Overall Validation Schema (for all steps, can be made step-specific)
export const overallValidationSchema = yup.object({
  personalInfo: personalInfoSchema,
  completedEducation: completedEducationItemSchema,
  presentEducation: presentEducationSchema,
  achievementsInfo: achievementItemSchema,
  familyDetails: familyDetailsSchema,
  scholarshipPurpose: scholarshipPurposeSchema,
  // uploadedDocuments: uploadedDocumentItemSchema,
  bankDetails: bankDetailsSchema,
});